function formatDate (date, fmt) {
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)); }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))); }
  }
  return fmt;
};

// 时间格式化1
// export function fullDate (dateText) {
//   if (dateText) {
//     return formatDate(new Date(dateText), 'yyyy-MM-dd hh:mm:ss');
//   }
//   return '';
// }
export function fullDate(dateText) {
  if (!dateText) {return ''; }
  const timeStr = new String(dateText).substr(0, 19).replace(/\-/g, '/').replace(/\T/g, ' ');
  return formatDate(new Date(new Date(timeStr).getTime() + 8 * 60 * 60 * 1000), 'yyyy-MM-dd hh:mm:ss');
}

// 时间格式化2
export function baseDate (dateText) {
  // if (dateText) {
  //   return formatDate(new Date(dateText), 'yyyy-MM-dd');
  // }
  // return '';
  if (!dateText) {return ''; }
  const timeStr = new String(dateText).substr(0, 19).replace(/\-/g, '/').replace(/\T/g, ' ');
  return formatDate(new Date(new Date(timeStr).getTime() + 8 * 60 * 60 * 1000), 'yyyy-MM-dd');
}
// 时间格式化1
export function formatDateTime (dateText, type = 'second', dateTime = 0) {
  if (dateText) {
    const weekList = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    // const time = new Date(new Date(dateText).getTime() + dateTime);
    const timeStr = new String(dateText).substr(0, 19).replace(/\-/g, '/').replace(/\T/g, ' ');
    const time = new Date(new Date(timeStr).getTime() + 8 * 60 * 60 * 1000 + dateTime);
    const year = time.getFullYear();
    const month = time.getMonth() + 1;
    const day = time.getDate();
    const hour = time.getHours();
    const minute = time.getMinutes();
    const second = time.getSeconds();
    const week = time.getDay();
    const showMonth = (month < 10 ? '0' + month : month);
    const showDay = (day < 10 ? '0' + day : day);
    const showHour = (hour < 10 ? '0' + hour : hour);
    const showMinute = (minute < 10 ? '0' + minute : minute);
    const showSecond = (second < 10 ? '0' + second : second);
    const showWeek = weekList[week];
    switch (type) {
    case 'year':
      return year;
    case 'month':
      return year + '-' + showMonth;
    case 'day':
      return year + '-' + showMonth + '-' + showDay;
    case 'hour':
      return year + '-' + showMonth + '-' + showDay + ' ' + showHour;
    case 'minute':
      return year + '-' + showMonth + '-' + showDay + ' ' + showHour + ':' + showMinute;
    case 'second':
      return year + '-' + showMonth + '-' + showDay + ' ' + showHour + ':' + showMinute + ':' + showSecond;
    case 'week':
      return showWeek;
    case 'date_week_time':
      return ['' + year + showMonth + showDay, showWeek, showHour + ':' + showMinute + ':' + showSecond];
    default:
      return year + '-' + showMonth + '-' + showDay + ' ' + showHour + ':' + showMinute + ':' + showSecond;
    }
  }
  return '';
}
// 字符串唯一
export function unique (value) {
  return Array.from(new Set(value.split(','))).toString();
}
// 显示值
export function showValue (value) {
  if (value) {
    return value;
  } else {
    return '';
  }
}
// 数组排序展示
export function arraySortShow (dataList) {
  const list = [...dataList];
  list.sort((a, b) => a.sort - b.sort);
  return list.map((item, index) => {
    return (index + 1) + '、' + item.value;
  }).join(' ; ');
}
// 数组显示（key）
export function arrayShowByKey (dataList, key) {
  let str = '';
  if (dataList && dataList.length) {
    dataList.forEach((item, index) => {
      str += item[key];
      if (index < dataList.length-1) {
        str += '，';
      }
    });
  }
  return str;
}
// 单位转换
export function unitChange (num, multiple) {
  if(num === 'null') {
    return '';
  }
  if (num === null || num === undefined) {
    return null;
  }
  const numStr = String(num);
  if (numStr.includes('.')) {
    const length = numStr.length - numStr.indexOf('.') - 1;
    const num2 = Math.pow(10, length);
    return (Number(num) * num2) / (multiple * num2);
  } else {
    return (Number(num) / multiple);
  }
}
// 保留两位小数
export function toDecimal(x) {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  var f = Math.floor(x*100)/100;
  var s = f.toString();
  var rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;
}
// 数组求和
export function listSum (list, key) {
  if (!list) {
    return 0;
  }
  let sum = 0;
  list.forEach(item => {
    if (key) {
      sum += Number(item[key]);
    } else {
      sum += Number(item);
    }
  });
  return sum;
}
